// extracted by mini-css-extract-plugin
module.exports = {"snapshotOverview":"snapshotOverview_snapshotOverview__975YK","title":"snapshotOverview_title__F8LER","snapshotOverviewDetails":"snapshotOverview_snapshotOverviewDetails__W5C94"};